<template>
  <div>
    <h1>{{ dName }}</h1>
    <span>{{ introduce }}</span>
      <el-card v-for="url in urls" :key="url" :body-style="{ padding: '0px' }">
        <el-image   :src="url"></el-image>
      </el-card>
  </div>
</template>
<script>
export default {
  name:"Details",
  data(){
    return{
      dName:this.$route.query.name,
      introduce:this.$route.query.introduce,
      urls:[require('@/assets/'+this.$route.query.id+'/'+this.$route.query.id+'.jpg'),
        require('@/assets/'+this.$route.query.id+'/'+this.$route.query.id+'_1.jpg'),
        require('@/assets/'+this.$route.query.id+'/'+this.$route.query.id+'_2.jpg'),
        require('@/assets/'+this.$route.query.id+'/'+this.$route.query.id+'_3.jpg'),
        require('@/assets/'+this.$route.query.id+'/'+this.$route.query.id+'_4.jpg'),]
    }
  },
  watch: {
    $route (to) {
      if (this.$route.query.id) {
        
        this.dName=this.$route.query.name
        this.introduce=this.$route.query.introduce
        if (this.$route.query.id.indexOf('lianzi')!=-1) {
          this.urls=[require('@/assets/lianzi/'+this.$route.query.id+'.jpg')]
        } else {
          this.urls=[require('@/assets/'+this.$route.query.id+'/'+this.$route.query.id+'.jpg'),
            require('@/assets/'+this.$route.query.id+'/'+this.$route.query.id+'_1.jpg'),
            require('@/assets/'+this.$route.query.id+'/'+this.$route.query.id+'_2.jpg'),
            require('@/assets/'+this.$route.query.id+'/'+this.$route.query.id+'_3.jpg'),
            require('@/assets/'+this.$route.query.id+'/'+this.$route.query.id+'_4.jpg'),]
        }
      }
    }
  },
  methods:{
  },
  activated() {
      //   this.dName=this.$route.query.id
      // this.introduce=this.$route.query.introduce
    },
}
</script>
<style lang="less" scoped>
.el-image {
    display: block; 
  text-align: center;

}
.el-card{
  width: 900px;
  margin: 10px auto;
}
</style>